import './styles/storefront.scss';

import app from './storefront';
import moment from 'moment';

angular.element(document).ready(function () {
    angular.bootstrap(document, [app.name], {
        strictDi: true
    });
    (function () {
        if (typeof window.CustomEvent === "function") return false; //If not IE

        function CustomEvent (event, params) {
            params = params || { bubbles: false, cancelable: false, detail: undefined };
            var evt = document.createEvent('CustomEvent');
            evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
            return evt;
        }

        CustomEvent.prototype = window.Event.prototype;

        window.CustomEvent = CustomEvent;
    })();

    (function ($) {

        // Polyfill for nodelist not supporting forEach()
        if (window.NodeList && !NodeList.prototype.forEach) {
            NodeList.prototype.forEach = Array.prototype.forEach;
        }

        $(document).foundation();

        window.resetFilters = function () {
            $('[data-grid-filter]').val('*').trigger('change');
        };

        var gridContainerEl = document.querySelectorAll('.js-grid-container');
        var gridItemsEl = document.querySelectorAll('.js-grid__item');

        function initCalendar () {
            var flatpickrEl = $('.js-flatpickr');

            if (flatpickrEl.length && flatpickr) {
                let minDate = 'today';
                let maxDate = moment().add(1, 'year').format('YYYY-MM-DD');

                let startDate = localStorage.getItem('start_date');
                if (startDate) {
                    minDate = moment(startDate, 'YYYY-MM-DD').format('YYYY-MM-DD');
                    maxDate = moment(localStorage.getItem('end_date'), 'YYYY-MM-DD').format('YYYY-MM-DD');
                }

                let fpOptions = {
                    altInput: true,
                    minDate: minDate,
                    maxDate: maxDate,
                    disableMobile: "true"
                };

                window.fpInput = flatpickr(".js-flatpickr", fpOptions);
            }
        }
        initCalendar();

        window.addEventListener('initCalendar', () => {
            initCalendar();
        });

        if (gridContainerEl.length && gridItemsEl.length && Isotope) {
            let isotopeContainers = [];
            gridContainerEl.forEach(gridContainer => {
                let grid = gridContainer.querySelectorAll('.js-grid') && gridContainer.querySelectorAll('.js-grid')[0];

                if (grid) {
                    isotopeContainers.push({
                        el: gridContainer,
                        isotope: new Isotope(grid, {
                            itemSelector: '.js-grid__item',
                            layoutMode: 'fitRows',
                            getSortData: {
                                a_z: '.js-grid__item__heading',
                                z_a: '.js-grid__item__heading',
                                highest: elem => parseFloat(elem.getAttribute('value')),
                                lowest: elem => parseFloat(elem.getAttribute('value')),
                                available: elem => elem.classList.contains('js-grid__item--not-available') ? 0 : 1
                            },
                            sortAscending: {
                                a_z: true,
                                z_a: false,
                                highest: false,
                                lowest: true,
                                available: false
                            },
                            visibleStyle: {
                                opacity: 1,
                                transform: 'translateY(0)',
                            },
                            hiddenStyle: {
                                opacity: 0,
                                transform: 'translateY(100px)',
                            }
                        })
                    });
                }
            });
            window.isotope = isotopeContainers;

            $('[data-grid-filter]').on('change', function () {
                let thisEl = $(this);
                let thisVal = thisEl.val();

                let otherFilter = $('[data-grid-filter]').not(thisEl).val();
                if (otherFilter && otherFilter !== '*') {
                    thisVal += `${otherFilter}`;
                }

                let noResultsEl = document.querySelectorAll('.js-search-message') && document.querySelectorAll('.js-search-message')[0];
                let hasNoResults = [];

                if (noResultsEl) {
                    noResultsEl.classList.remove('is-active');
                };

                isotopeContainers.forEach(container => {
                    let heading = container.el.querySelectorAll('.js-grid__heading') && container.el.querySelectorAll('.js-grid__heading')[0];

                    container.isotope.arrange({ filter: thisVal, sortBy: 'available' });

                    if (!container.isotope.filteredItems.length) {
                        hasNoResults.push(true);

                        if (heading) {
                            heading.classList.add('is-hidden');
                        }
                        return;
                    }

                    if (heading) {
                        heading.classList.remove('is-hidden');
                    }
                });

                if ((hasNoResults.length === isotopeContainers.length) && noResultsEl) {
                    noResultsEl.classList.add('is-active');
                }

                setTimeout(function () {
                    window.dispatchEvent(new CustomEvent('imgixRefresh'));
                }, 250);
            });


            $('[data-grid-sort]').on('change', function () {
                let thisVal = $(this).val();
                isotopeContainers.forEach(container => {
                    container.isotope.arrange({ sortBy: ['available', thisVal] });
                });
            });

            let category;
            try {
                category = new URL(window.location).searchParams.get('category');
            } catch (error) {
                let url = window.location.href;
                let regex = new RegExp("[?&]category(=([^&#]*)|&|#|$)"),
                    results = regex.exec(url);
                if (results && results[2]) { category = decodeURIComponent(results[2].replace(/\+/g, " ")); }
            }
            if (category) setTimeout(() => $('.c-select--categories').val('.' + category).trigger('change'), 750);
        }

        let offcanvasLeftEl = $('.off-canvas.position-left'),
            offcanvasRightEl = $('.off-canvas.position-right');

        new Foundation.OffCanvas(offcanvasLeftEl);
        new Foundation.OffCanvas(offcanvasRightEl);

        offcanvasLeftEl.on('opened.zf.offcanvas', function () {
            document.body.classList.add('offcanvas-open');
        });
        offcanvasRightEl.on('opened.zf.offcanvas', function () {
            document.body.classList.add('offcanvas-open');
        });

        offcanvasLeftEl.on('closed.zf.offcanvas', function () {
            document.body.classList.remove('offcanvas-open');
        });
        offcanvasRightEl.on('closed.zf.offcanvas', function () {
            document.body.classList.remove('offcanvas-open');
        });

        let groupDropdownEl = $('.js-dropdown');
        if (groupDropdownEl.length) {
            new Foundation.Dropdown(groupDropdownEl);
        }

        // Detect request animation frame
        let scroll = window.requestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.msRequestAnimationFrame ||
            window.oRequestAnimationFrame ||
            // IE Fallback, you can even fallback to onscroll
            function (callback) { window.setTimeout(callback, 1000 / 60); };

        function scrollLoop () {

            let top = window.pageYOffset;

            if (top > 100) {
                document.body.classList.add('has-scrolled');
            } else {
                document.body.classList.remove('has-scrolled');
            }

            // Recall the scrollLoop
            scroll(scrollLoop);
        }
        // Call the scrollLoop for the first time
        scrollLoop();

        $('.js-flickity').on('change.flickity', function () {
            setTimeout(function () {
                window.dispatchEvent(new CustomEvent('imgixRefresh'));
            }, 750);
        });
    })(jQuery);
});



// WEBPACK FOOTER //
// ./frontend/storefront/index.js